import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import ProContainer from './ProContainer';

import '../TorontoFleets.css';

const AutzuPro = () => (
  <Fragment>
    <Helmet>
      <title>Autzu PRO</title>
      <meta
        name="description"
        content="Drive Autzu Pro on Uber & Lyft, starting from $6/hour"
      />
    </Helmet>
    <ProContainer />
  </Fragment>
);

export default AutzuPro;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPro/index.js